/**
 * Tms枚举值
 */

/**
 * 班次中“非固定”选项枚举（司机 / 车辆 / 车型）
 */
export enum NonFixedOption {
  Driver = 'NON_FIXED_DRIVER',
  Vehicle = 'NON_FIXED_VEHICLE',
  Model = 'NON_FIXED_MODEL',
}

/**
 * 途经点类型枚举
 */
export enum WaypointTypeEnum {
  Origin = 1,        // 起点
  Waypoint = 2,      // 途经点
  Destination = 3,   // 终点
}

/**
 * 通用激活状态枚举（适用于 route, schedule, carrier, transit_routes, route_waypoint 等）
 */
export enum TmsStatusEnum {
  InActive = 0,  // 禁用/未激活
  Active = 1,    // 启用/激活
}

/**
 * 路线类型枚举
 */
export enum TmsRouteTypeEnum {
  Linehaul = 1,  // 干线
  Feeder = 2,    // 支线
  Handover = 3,  // 交接
}

/**
 * 交接方类型枚举
 */
export enum HandoverTypeEnum {
  LocalLastMileCarrier = 1,    // 本地尾程商
  LinehaulCarrier = 2,  // 干线承运商
}

/**
 * 承运商类型枚举
 */
export enum TmsCarrierTypeEnum {
  Linehaul = 1,           // 干线
  Feeder = 2,          // 支线
  LinehaulAndFeeder = 3, // 干线+支线
}

/**
 * 承运商来源类型（与后端 TmsCarrier.sourceType 一致）：1-内部，2-三方
 * @deprecated 该字段在TMS交接方需求中已弃用，不再使用
 */
export enum TmsCarrierSourceTypeEnum {
  Internal = 1,
  ThirdParty = 2,
}

/**
 * 任务来源枚举
 */
export enum TmsTaskSourceEnum {
  System = 1,    // 系统创建
  Manual = 2,     // 人工创建
}

/**
 * 路线业务来源枚举
 */
export enum TmsBusinessTypeEnum {
  OwnRoute = 1,  // 自有路线
  TikTok = 2,    // TikTok
  TemuGA = 3,    // Temu GA
  TemuSCF = 4,   // Temu SCF
}

/**
 * 站点来源枚举（与后端 TmsStationSourceEnum 对应）
 */
export enum TmsStationSourceEnum {
  INTERNAL = 'INTERNAL',  // 内部站点（warehouse）
  EXTERNAL = 'EXTERNAL',  // 外部站点（external_station）
}

/**
 * 外部站点类型枚举（与后端 ExternalStationType 对应）
 */
export enum ExternalStationType {
  TEMU_GA = 1,   // Temu GA
  TEMU_SCF = 2,  // Temu SCF
  TEMU_HANDOVER = 3, // TEMU 交接类型
  TIKTOK = 4, // TikTok
}

/**
 * 任务类型枚举
 */
export enum TmsTaskTypeEnum {
  Regular = 1,    // 常规
  Temporary = 2,  // 临时
  ThirdParty = 3, // 三方
}

/**
 * 任务状态枚举
 */
export enum TmsTaskStatusEnum {
  Draft = 1,       // 草稿
  Published = 2,     // 已发布
  InProgress = 3,    // 进行中
  Completed = 4,     // 已完成
  Abnormal = 5,      // 异常
  Cancelled = 6,     // 已取消
}

/**
 * 任务途经点状态枚举
 */
export enum TmsTaskWaypointStatusEnum {
  Planned = 1,   // 待到站
  Arrived = 2,   // 已到站
  Done = 3,      // 已发车
  PENDING_DEPARTURE = 4    // 待发车
}

/**
 * 异常原因类型枚举
 */
export enum ExceptionReasonEnum {
  VEHICLE_BREAKDOWN = 1,      // 车辆故障
  TRAFFIC_ACCIDENT = 2,       // 交通事故
  WEATHER = 3,                // 天气原因
  TRAFFIC_JAM = 4,            // 交通堵塞
  WAREHOUSE_DELAY = 5,        // 仓内延误
  OTHER = 6                   // 其他
}

/**
 * 发车频率枚举
 */
export enum DepartureFrequencyEnum {
  Monday = 1,      // 星期一
  Tuesday = 2,     // 星期二
  Wednesday = 3,   // 星期三
  Thursday = 4,     // 星期四
  Friday = 5,      // 星期五
  Saturday = 6,    // 星期六
  Sunday = 7,      // 星期日
}

/**
 * 车辆状态枚举
 */
export enum TmsVehicleStatus {
  DISABLED = 0,      // 停用
  AVAILABLE = 1,     // 可用
  MAINTENANCE = 2,   // 维修中
}

/**
 * 作业类型枚举（装车 / 卸车，tms 通用）。（1=装车、2=卸车），
 */
export enum TmsOperationTypeEnum {
  Loading = 1,    // 装车
  Unloading = 2,  // 卸车
}

/**
 * 操作来源枚举（tms_operation_log.operation_source）
 */
export enum TmsOperationSourceEnum {
  APP = 1,   // APP司机端
  PDA = 2,   // PDA
  PC = 3,    // PC服务端
}

/**
 * 发车事件类型枚举
 */
export enum TmsDepartureEventTypeEnum {
  LINEHAUL_ORIGIN_HUB_DEPARTURE = 1, // 干线始发HUB发车
  OTHER_DEPARTURE = 2,                // 其他发车
  FEEDER_DEST_HUB_DEPARTURE = 3,     // 支线目的地HUB发车
  HANDOVER = 4,                       // 交接
}

/**
 * 出发日归属枚举（班次的任务归属日期偏移）
 */
export enum DepartureDayOffsetEnum {
  PreviousDay = -1,  // 前一日
  CurrentDay = 0,    // 当日
}

// 中心仓ID：「全国(适用所有中心仓)」；其他值才是具体中心仓ID。文案走 i18n key common.allCenterWarehouse
export const ALL_CENTER_WAREHOUSE_ID = '0';